module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "page-footer"
    }
  }, [_c('hr'), _vm._v(" "), _c('h4', [_vm._v("Links")]), _vm._v(" "), _c('ul', _vm._l((_vm.links), function(link) {
    return _c('li', {
      key: link.name
    }, [_c('a', {
      attrs: {
        "href": link.href,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(link.name))])])
  }), 0), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v("Copyright © " + _vm._s(_vm.currentYear) + " by "), _c('a', {
    attrs: {
      "href": "https://www.studio308.co"
    }
  }, [_vm._v("Studio 308")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b3cb380"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageFooter.vue
// module id = 76
// module chunks = 0